import React from "react";
import { Building2, Layers, Globe, Handshake } from "lucide-react";
import { Card } from "@/components/ui/card";

const ICONS = { Building2, Layers, Globe, Handshake };

export const ReasonItem = ({ reason }) => {
  const Icon = ICONS[reason.icon] || Building2;
  return (
    <div className="flex items-start gap-4">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#eef2f8]">
        <Icon className="h-5 w-5 text-[#123055]" aria-hidden="true" />
      </span>
      <div>
        <h3 className="text-base font-semibold text-[#0b1d3a]">{reason.title}</h3>
        <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{reason.text}</p>
      </div>
    </div>
  );
};

export const StatCard = ({ stat }) => (
  <Card className="h-full rounded-[16px] border-[#cfe6e7] bg-[#eef7f7] p-5">
    <p className="font-display text-2xl font-semibold text-[#0b1d3a] sm:text-3xl">{stat.value}</p>
    <span className="mt-2 block h-[3px] w-8 rounded-full bg-[#f28a2e]" aria-hidden="true" />
    <p className="mt-3 text-xs leading-relaxed text-slate-600 sm:text-sm">{stat.label}</p>
  </Card>
);

export const ProcessCard = ({ item }) => {
  const Icon = ICONS[item.icon] || Building2;
  return (
    <Card className="group flex h-full flex-col rounded-[16px] border-slate-200 bg-white p-5 shadow-[var(--shadow-sm)] transition-shadow hover:shadow-[var(--shadow-md)] sm:p-6">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#cfe6e7] bg-white text-xs font-bold text-[#0f6e73] transition-colors group-hover:bg-[#148a8f] group-hover:text-white">
          {item.step}
        </span>
        <Icon className="h-5 w-5 text-[#123055]" aria-hidden="true" />
      </div>
      <h3 className="mt-5 text-base font-semibold text-[#0b1d3a] sm:text-lg">{item.title}</h3>
      <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{item.text}</p>
    </Card>
  );
};
